import { render, staticRenderFns } from "./composantVignette.vue?vue&type=template&id=2c159142&scoped=true"
import script from "./composantVignette.vue?vue&type=script&lang=js"
export * from "./composantVignette.vue?vue&type=script&lang=js"
import style0 from "./composantVignette.vue?vue&type=style&index=0&id=2c159142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c159142",
  null
  
)

export default component.exports